import { Box, Paper, Transition } from '@mantine/core';
import type { PropsWithChildren } from 'react';
export type AsideChatModalProp = {
  active: boolean;
  onClickOutside?: () => void;
};
export const AsideChatModal: React.FC<PropsWithChildren<AsideChatModalProp>> = ({
  children,
  active
}) => {
  return <Transition mounted={active} transition="fade-up" duration={150} timingFunction="ease">
      {styles => <>
          {<Box style={styles} pos="absolute" inset="auto 0px 88px">
              <Box h={16} bg="linear-gradient(180deg, rgba(23,26,30,0) 0%, rgba(23,26,30,1) 100%)">
                {''}
              </Box>
              <Paper radius={0} bg="#171A1EE5" p={10}>
                {children}
              </Paper>
            </Box>}
        </>}
    </Transition>;
};